import React from 'react';

import { ICardWrapper } from '../../types/ICardWrapper';

import './cardWrapper.scss';

const CardWrapper: React.FC<ICardWrapper> = ({ children, width, className, gridColumnEnd, gridRowEnd }) => {
  return (
    <div className={`card-wrapper ${className ? className : ''}`}
         style={{ width: width, gridColumnEnd: gridColumnEnd, gridRowEnd: gridRowEnd }}>
      {children}
    </div>
  );
};

export default CardWrapper;
